import { render, staticRenderFns } from "./addParaseRcord.vue?vue&type=template&id=4501b739&scoped=true"
import script from "./addParaseRcord.vue?vue&type=script&lang=js"
export * from "./addParaseRcord.vue?vue&type=script&lang=js"
import style0 from "./addParaseRcord.vue?vue&type=style&index=0&id=4501b739&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4501b739",
  null
  
)

export default component.exports